import { SectionItem } from '@features/shift-post-v2/components'
import { Flex } from '@pinchenterprisesnpm/friday-ui'
import { SHIFT_TRAINING_SHIFTS_TOOLTIP } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils/constants'
import { FormSwitchContainer } from '@src/features/shift-post-v2/steps/shift-details-step/components/additional-options-section/additional-options-section.styles'
import { FormSwitch } from '@src/ui/components/common/FormComponents'
import { connect } from 'formik'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { useSelector } from 'react-redux'
import { selectBusinessEntity } from '@src/data/BusinessEntity/selectors'
import { FEATURE_TOGGLE_SHADOW_BAN } from '@src/config/featureToggles'
import { selectOriginalShift } from '@src/data/FullEditShift/selectors'
import { confirmModal } from '@src/helpers/GenericConfirmModal'
import { IAdditionalOptionsSectionProps } from './additional-options-section.types'

export const AdditionalOptionsSection = connect<IAdditionalOptionsSectionProps>(
  ({ formik, sourcePage }) => {
    const { values, setFieldValue } = formik

    const originalShift = useSelector(selectOriginalShift)
    const businessEntity = useSelector(selectBusinessEntity)
    const isMandatoryMinAge = (businessEntity?.min_age ?? 0) >= 21
    const isTrainingModeAllowed = businessEntity?.training_mode
    const shouldAlcoholServiceButtonShow = businessEntity?.industry?.must_be_min_age

    /**
     * Field editing is disabled if template is not selected.
     */
    const editingDisabled = sourcePage === ShiftPostPage.POST_SHIFT && !values.template_id

    return (
      <SectionItem title='Additional Options' hasEdit={false}>
        <Flex direction='column'>
          {isTrainingModeAllowed ? (
            <FormSwitchContainer>
              <FormSwitch
                label='Is this a Training Shift'
                leftLabel='No'
                rightLabel='Yes'
                name='training_mode'
                value={values.training_mode ?? false}
                handleChange={setFieldValue}
                fieldColumns={10}
                labelTooltipMessage={SHIFT_TRAINING_SHIFTS_TOOLTIP}
                isDisabled={editingDisabled}
              />
            </FormSwitchContainer>
          ) : null}

          {shouldAlcoholServiceButtonShow ? (
            <FormSwitchContainer>
              <FormSwitch
                label='Is alcohol service required'
                name='min_age'
                labelTooltipMessage={
                  isMandatoryMinAge
                    ? 'Please contact Upshift support if you need to turn this setting off for this shift.'
                    : 'This shift requires the employee to be 21 or older.'
                }
                isDisabled={isMandatoryMinAge || editingDisabled}
                value={values.min_age >= 21 ? true : false}
                handleChange={(field: string, value: any) => {
                  if (value) {
                    setFieldValue(field, 21)
                  } else {
                    setFieldValue(field, 0)
                  }
                }}
                leftLabel='No'
                rightLabel='Yes'
              />
            </FormSwitchContainer>
          ) : null}
          {FEATURE_TOGGLE_SHADOW_BAN && sourcePage === ShiftPostPage.EDIT_SHIFT ? (
            <FormSwitchContainer>
              <FormSwitch
                label={
                  <>
                    Bypass Shadowban/
                    <br />
                    Early Access
                  </>
                }
                name='bypass_mechanism_enabled'
                value={!!values.bypass_mechanism_enabled}
                isDisabled={originalShift.bypass_mechanism_enabled || editingDisabled}
                handleChange={(_, value) => {
                  if (value === true) {
                    confirmModal({
                      title: 'Are you sure?',
                      message:
                        'This will allow the shift to be visible by all Upshifters immediately.' +
                        'This action cannot be undone.',
                      height: 250,
                      width: 500,
                      onConfirm: () => {
                        setFieldValue('bypass_mechanism_enabled', value)
                      },
                    })
                  } else {
                    setFieldValue('bypass_mechanism_enabled', value)
                  }
                }}
                leftLabel='No'
                rightLabel='Yes'
                labelTooltipMessage='Remove all restrictions for how this shift is displayed.'
              />
            </FormSwitchContainer>
          ) : null}
        </Flex>
      </SectionItem>
    )
  }
)
